export const GET_ALL_SYNC = 'GET_ALL_SYNC';
export const SET_SYNC_COUNT = 'SET_SYNC_COUNT';
export const GET_SYNC_AGENT = 'GET_SYNC_AGENT';
export const GET_SYNC_AGENT_ATTRIBUTE_MAP = 'GET_SYNC_AGENT_ATTRIBUTE_MAP';
export const GET_SYNC_AGENT_OU_NODE = 'GET_SYNC_AGENT_OU_NODE';
